module.exports = __webpack_public_path__ + "img/img_review_event_pop_01.f316b2df.png";